module.exports = __webpack_public_path__ + "img/03.e770bd1b.jpg";